<template>
  <div :data-qa="dataQa" class="vc-list-container">
    <ul v-if="!isEmptyList" class="vc-list">
      <VcBaseListItem
        v-for="item in items"
        v-bind="item"
        :key="item.identifier"
        :selected-class="getSelectedClass"
        :data-qa="`${dataQa}-${item.identifier}`"
        @click="$emit('select', item.identifier, !item.selected)">
        <template #default>
          <slot v-bind="item">
            {{ item.label }}
          </slot>
        </template>
      </VcBaseListItem>
    </ul>
    <template v-else>
      <slot name="emptyList">
        <VcEmptyState
          :title="noItemsTitle"
          :subtitle="noItemsMsg"
          size="sm"
          class="VcListEmptyState"
          :data-qa="`${dataQa}-empty`"
          :image="imagePath" />
      </slot>
    </template>
  </div>
</template>

<script>
import VcEmptyState from '../../VcEmptyState/VcEmptyState.vue';
import VcBaseListItem from '../VcBaseListItem/VcBaseListItem.vue';

export default {
  name: 'VcList',
  components: { VcEmptyState, VcBaseListItem },
  props: {
    items: {
      type: Array,
      required: true,
      validator: (items) => items.every((item) => !isNaN(item.identifier)),
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    emptyListMsg: {
      type: String,
    },
    emptyListTitle: {
      type: String,
    },
    imagePath: {
      type: String,
    },
    dataQa: {
      type: String,
      default: 'vc-list',
    },
  },
  computed: {
    getSelectedClass() {
      return this.multiple ? 'multiple' : 'single';
    },
    isEmptyList() {
      return !this.items.length;
    },
    noItemsTitle() {
      return this.emptyListMsg || this.$dst('ds.listbox.empty_list');
    },
    noItemsMsg() {
      return this.emptyListTitle || this.$dst('ds.list.empty_list_description');
    },
  },
};
</script>

<style lang="scss" scoped>
.vc-list-container {
  width: 100%;
}

.vc-list {
  width: 100%;
  margin: var(--size-value0);
  padding: var(--size-value0);
}

.VcListEmptyState {
  margin: var(--size-value4);
}
</style>
